import { BRAND_LOGO_SIZE, BRAND_LOGO_SRC, BRAND_LOGO_SRCSET, BRAND_NAME, BRAND_TAGLINE } from "./brand";

const SIZES = {
  sm: { text: "text-[19px]", img: "h-12", sizes: "80px", tag: "text-[9px]" },
  md: { text: "text-[24px]", img: "h-[118px]", sizes: "192px", tag: "text-[10px]" },
  lg: { text: "text-[40px] sm:text-[48px]", img: "h-[150px] sm:h-[210px]", sizes: "(min-width: 640px) 342px, 244px", tag: "text-xs" },
};

export const FlagStripe = ({ className = "" }) => (
  <div className={`flex h-1 w-full ${className}`} aria-hidden="true">
    <span className="flex-1 bg-primary" /><span className="flex-1 bg-accent" /><span className="flex-1 bg-primary" />
  </div>
);

export const Logo = ({ size = "md", tagline = true, tone = "light" }) => {
  const s = SIZES[size];
  if (BRAND_LOGO_SRC) {
    return (
      <div className="select-none leading-none" data-testid="app-logo">
        <img src={BRAND_LOGO_SRC} srcSet={BRAND_LOGO_SRCSET} sizes={s.sizes} alt={`${BRAND_NAME} – ${BRAND_TAGLINE}`}
          width={BRAND_LOGO_SIZE.width} height={BRAND_LOGO_SIZE.height} decoding="async" draggable={false}
          className={`${s.img} w-auto max-w-full object-contain`} data-testid="app-logo-image" />
      </div>
    );
  }
  return (
    <div className="select-none leading-none" data-testid="app-logo">
      <div className={`brand-wordmark ${s.text}`} aria-label={BRAND_NAME} data-testid="app-logo-text">
        <span className="text-primary">DA</span> <span className="text-accent">LIL</span> <span className="text-primary">SHOP</span>
      </div>
      {tagline && (
        <div className={`mt-1.5 font-semibold uppercase tracking-[0.22em] ${s.tag} ${tone === "dark" ? "text-white/70" : "text-foreground/60"}`} data-testid="app-logo-tagline">
          {BRAND_TAGLINE}
        </div>
      )}
    </div>
  );
};
